import SessionStore from 'stores/shared/session';
import ApiService from '../api';

const ContactService = {
  sendMessage(message) {
    return ApiService.fetch({
      url: `/api/users/${message.guide_id}/contact`,
      method: 'POST',
      params: { ...message, ...SessionStore._getCSRFTokenObject() },
    });
  },
};

export default ContactService;
